import Dot from '@groovehq/internal-design-system/lib/components/Dot/Dot'

export default function TagDropdownIndicator({
  name,
  color,
  conversationCount,
}) {
  return (
    <div>
      <Dot color={color} className="grui mr-5" />
      {`${name}${conversationCount !== null ? ` (${conversationCount})` : ''}`}
    </div>
  )
}
